import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import normali per tutte le lingue
import enTranslation from './locales/en/translation.json';
import itTranslation from './locales/it/translation.json';
import deTranslation from './locales/de/translation.json';
import frTranslation from './locales/fr/translation.json';
import esTranslation from './locales/es/translation.json';
import nlTranslation from './locales/nl/translation.json';
import plTranslation from './locales/pl/translation.json';
import ptTranslation from './locales/pt/translation.json';

// Solo il cinese con require (SOLUZIONE PER IL PROBLEMA)
const zhTranslation = require('./locales/zh/translation.json');

// Configurazione i18next
i18n
  .use(initReactI18next)
  .init({
    lng: 'it', // Lingua di default
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    resources: {
      en: {
        translation: enTranslation,
      },
      it: {
        translation: itTranslation,
      },
      de: {
        translation: deTranslation,
      },
      fr: {
        translation: frTranslation,
      },
      es: {
        translation: esTranslation,
      },
      nl: {
        translation: nlTranslation,
      },
      pl: {
        translation: plTranslation,
      },
      pt: {
        translation: ptTranslation,
      },
      zh: {
        translation: zhTranslation,
      },
    },
  });

// Esponi i18n per il debug in console
if (typeof window !== 'undefined') {
  window.i18n = i18n;
}

export default i18n;